export default "__VITE_ASSET__C87SY0x8__"